export default {
  // Set forms loaded state to true
  formsTimestamp(state) {
    state.formsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  // Reset forms loaded state to true
  formsTimestampReset(state) {
    state.formsTimestamp = null;
  },
  // Set forms
  forms(state, payload) {
    state.forms = payload;
  },
  // Set submissions
  submissions(state, payload) {
    state.submissions = payload;
  },
};
